<form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
  <div class="row">
    <div class="form-group col-md-8">
      <label>Email</label>
      <input class="form-control" [ngClass]="setClassInvalid(forgotPasswordForm, 'email')" type="email" name="Email"
             formControlName="email" placeholder="Email" minlength="3" maxlength="100" required>
      <div class="invalid-feedback">Invalid email.</div>
    </div>
  </div>
  <button class="btn btn-primary" type="submit" [disabled]="!forgotPasswordForm.valid">
    <i class="fa fa-paper-plane"></i> Send reset link
  </button>
</form>